import React from 'react';

import RatingDisplayV5 from '../../Profile/RatingDisplayV5';

import { getRatingDetails, setRatingChoice } from '../../../utils';
import styles from './homeHeader.scss';

const HomeHeader = (props) => {
    const { auth, profile } = props;
    const { isPowered } = auth?.user || {};

    const rating = getRatingDetails(setRatingChoice({ player: profile }), isPowered, true, false, false);
    const isPro = profile?.isPro;

    let displayedRatingsCount = 0;
    if (rating.showTennisRating) {
        displayedRatingsCount += 1;
    }
    if (rating.showPickleballRating) {
        const hideUtpRating = rating.utrRange?.pbrRange && rating.showPBRRating;
        if (!hideUtpRating) {
            displayedRatingsCount += 1;
        }
    }

    const onTennisGetRatedClick = () => {
        props.history.push(`/onboarding-survey?return=/home`);
    };

    const onPickleballGetRatedClick = () => {
        props.history.push(`/pickleball-survey?return=/home`);
    };

    const hasSinTitle = displayedRatingsCount > 1 ? 's' : '';

    return (
        <div className={styles.homeHeader} data-testid="home-header">
            <div className="container">
                <div className={styles.header}>
                    <div className={styles.ratingsSection}>
                        <div className={styles.title} data-testid="home-header.title">
                            My Rating{hasSinTitle}
                        </div>
                        <div className={styles.ratingContainer}>
                            <RatingDisplayV5
                                profileData={profile}
                                handleSignInCLick={() => {
                                    props.handleShowLoginPopUp('ratingDisplay');
                                }}
                                isProProfile={isPro}
                                auth={props.auth}
                                isOwnProfile={true}
                                onTennisGetRatedClick={onTennisGetRatedClick}
                                onPickleballGetRatedClick={onPickleballGetRatedClick}
                                data-testid="home-header.rating"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeHeader;
